import {AfterViewInit, ChangeDetectorRef, Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';

@Component({
  selector: 'app-progress-body',
  templateUrl: './progress-body.component.html',
  styleUrls: ['./progress-body.component.scss']
})
export class ProgressBodyComponent implements OnInit, AfterViewInit {
  @ViewChild('ngRect') rect: ElementRef;
  valueY = 0;

  colors: string[] = ['#ffcb0070', '#ff830070', '#ff464478'];

  @Input() percentage: number = 0;
  constructor(
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    try {
      this.valueY = ((100 - parseFloat(this.rect.nativeElement.getAttribute('data-percent'))) * parseFloat(this.rect.nativeElement.getAttribute('height'))) / 100;
      this.cdr.detectChanges();
    } catch (e) {
      console.log(e);
    }
  }
}
